import React, { type ReactNode } from 'react';
import { cn } from '../components/utils';
import clsx from 'clsx';

export interface SectionProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
	header?: ReactNode;
	footer?: ReactNode;
	bodyClassName?: string;
}

export function Section({ header, footer, className, children, bodyClassName, ...props }: SectionProps) {
	return (
		<div className={cn('rounded-xl border bg-white border-gray-200 ', className)} {...props}>
			{header}
			<div className={clsx('px-5 py-4', bodyClassName)}>{children}</div>
			{footer}
		</div>
	);
}
